import { mutatorAction } from 'satcheljs';
import { getUserConfiguration } from 'owa-session-store';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
const assign = require('object-assign');

export default mutatorAction('updateUserOptions', function updateUserOptions(
    newUserOptions: UserOptionsType
) {
    assign(getUserConfiguration().UserOptions, newUserOptions);
});
